export default {
  width: '15.625rem',
  option: {
    padding: {
      top: '0.9375rem',
      bottom: '0.9375rem',
    },
  },
  indicator: {
    border: {
      thickness: '2px',
      style: 'solid',
    },
  },
};
